<template>
  <section class="xport-home">
    <div
      style="height: 56.3vw; width: 100vw; position: relative; top: -80px"
      class="flex items-center"
    >
      <div style="height: 100%; width: 100%; position: absolute">
        <!-- <video loop muted autoplay class="main-home-mov">
          <source src="https://xport-1315143236.cos.ap-shanghai.myqcloud.com/www/home.mp4" type="video/mp4" />
        </video> -->
        <iframe
          frameborder="0"
          height="100%"
          width="100%"
          scrolling="no"
          src="https://play.vidyard.com/XknRcFpWoEAU3cji4aFy5t?disable_popouts=1&amp;v=4.3.10&amp;type=inline&amp;hide_playlist=1&amp;name_overlay=0&amp;viral_sharing=0&amp;embed_button=0&amp;loop=1&amp;hidden_controls=1"
          title="Masthead Video - July 2024 - Homepage"
          style="opacity: 1; background-color: transparent"
        ></iframe>
        <div
          style="
            position: absolute;
            height: 100%;
            width: 100%;
            background-color: #000;
            opacity: 0.56;
            top: 0;
            left: 0;
          "
        ></div>
      </div>
      <div class="container-main py-12 home-one">
        <div class="flex items-center justify-between">
          <div class="flex flex-col gap-8 flex-1">
            <h1 class="title text-5xl font-bold leading-tight c-white">
              通过Xport，打造通向世界的智能出海通道
            </h1>
            <p class="desc text-lg font-medium c-white">
              跨智寰宇作为新时代跨境电商的智能服务平台，我们以AI为驱动，致力于为全球卖家构建高效、安全、可持续的出海通道，助您掌握全球市场节奏，实现品牌全球化增长。
            </p>
            <div class="flex items-center gap-8 mt-4">
              <button
                style="border-radius: 9999px !important"
                class="nb-btn-primary py-3 px-8"
                @click="handleJumpPage"
              >
                立即启航
              </button>
              <button class="nb-color-primary font-medium">或联系专家</button>
            </div>
            <div class="flex items-center">
              <div class="flex items-center pl-20 pr-20 eco-list">
                <img src="@/assets/eco/tiktok.svg" />
                <img src="@/assets/eco/temu.svg" />
                <img src="@/assets/eco/shopify.svg" />
                <img src="@/assets/eco/amazon.png" width="120" />
              </div>
            </div>
          </div>
          <!-- <div class="flex-1 flex items-center justify-end">
          <div style="padding: 20px; background-color: #fff; border-radius: 10px;    box-shadow: 0 1px 11px 0 #aaa;">
            <iframe class="nb-bg-shadow" style="width: 500px;height:280px;" src="https://play.vidyard.com/XknRcFpWoEAU3cji4aFy5t?disable_popouts=1&v=4.3.10&type=inline&hide_playlist=1&name_overlay=0&viral_sharing=0&embed_button=0&loop=1&hidden_controls=1"></iframe>
          </div>
        </div> -->
        </div>
      </div>
    </div>

    <!-- <div class="home-two">
      <div class="two-inner">
        <div class="two-item">
          <div class="item-num">GLBE</div>
          <div class="item-text">
            <img src="@/assets/eco/tiktok.svg" alt="" />
          </div>
        </div>
        <div class="item-line"></div>
        <div class="two-item">
          <div class="item-num">> 1000</div>
          <div class="item-text">
            <img src="@/assets/eco/temu.svg" alt="" />
          </div>
        </div>
        <div class="item-line"></div>
        <div class="two-item">
          <div class="item-num">> 200</div>
          <div class="item-text">
            <img src="@/assets/eco/shopify.svg" alt="" />
          </div>
        </div>
        <div class="item-line"></div>
        <div class="two-item">
          <div class="item-num">> 30</div>
          <div class="item-text">LOCATIONS</div>
        </div>
      </div>
    </div> -->
    <div class="home-three">
      <div class="three-inner" :style="{ '--num': threeCarouselList.length }">
        <img
          v-for="(item, i) in threeCarouselList"
          :key="'key' + item.id + i"
          :src="item.imageUrl"
          alt=""
        />
      </div>
    </div>
    <div class="home-four">
      <div class="four-1">
        <img src="@/assets/home/home-four-1.jpg" alt="" />
      </div>
      <div class="four-2">
        <div class="four-2-top">
          <h2>让世界成为你的市场</h2>
          <p>Xport智链全球，外贸转型跨境电商，一步到位</p>
          <p>
            不只是卖产品，而是打造全球品牌。Xport为您铺设智能出海通道，让您的品牌真正拥有世界。
          </p>
        </div>
        <div class="four-2-bottom">
          <img src="@/assets/home/tiktok.png" alt="" />
        </div>
      </div>
      <div class="four-3">
        <img src="@/assets/home/home-four-3.jpg" alt="" />
      </div>
    </div>
    <div class="home-five">
      <div class="five-inner">
        <h2>全球智能跨境贸易平台</h2>
        <p>
          Xport以AI为驱动，构建“全球赋能、全球情报、全球需求”三大核心支柱，打造高效、安全、可持续的智能出海通道，全面赋能传统外贸向跨境电商升级转型。
        </p>
        <ul>
          <li>
            <img src="@/assets/home/Hp-IconBox1-Global-Enablement.svg" alt="" />
            <h3>全球赋能</h3>
            <p>
              提供从供应链整合、物流履约、平台对接到营销获客的一站式智能服务体系，打通跨境电商全流程，实现出海更高效、更轻松。
            </p>
          </li>
          <li>
            <img
              src="@/assets/home/Hp-IconBox2-global-Intelligence.svg"
              alt=""
            />
            <h3>全球情报</h3>
            <p>
              通过AI与大数据洞察全球电商趋势、市场动态与竞品情报，精准指导选品、定价、渠道和策略决策，让您掌握全球市场节奏，领先一步。
            </p>
          </li>
          <li>
            <img src="@/assets/home/Hp-IconBox3-Global-demand.svg" alt="" />
            <h3>全球需求</h3>
            <p>
              链接全球主流电商平台与海量真实采购商，实现从“人找货”到“货找人”的智能转化，让您直达全球消费者，打造属于自己的海外品牌资产。
            </p>
          </li>
        </ul>
        <div class="btn-box">
          <a class="btn" @click="jump('/platform')">探索我们的平台</a>
        </div>
      </div>
    </div>
    <HomeSix />
    <div class="home-seven">
      <div class="seven-inner">
        <h2>推动您的全球<br />电子商务增长</h2>
        <a>与我们的专家交谈</a>
      </div>
    </div>
    <HomeEight />
    <div class="home-nine">
      <div class="nine-inner">
        <h2>全球化品牌成长的全链路赋能体系</h2>
        <ul>
          <li>
            <div class="img">
              <img src="../../assets/home/HP-sec07-img-01.jpg" alt="" />
            </div>
            <div class="text">
              <h3>推动客户成功</h3>
              <p>建立真正面向全球的可持续业务体系</p>
              <a class="explore" @click="jump('/success-stories')">探讨</a>
            </div>
          </li>
          <li>
            <div class="img">
              <img
                src="../../assets/home/shutterstock_2368579157-2-768x512.jpg"
                alt=""
              />
            </div>
            <div class="text">
              <h3>知识共享</h3>
              <p>让知识成为每位卖家拓展全球的利器</p>
              <a class="explore" @click="jump('/knowledge-centre')">探讨</a>
            </div>
          </li>
          <li>
            <div class="img">
              <img src="../../assets/home/HP-sec07-img-03.jpg" alt="" />
            </div>
            <div class="text">
              <h3>伙伴关系</h3>
              <p>全球合作伙伴生态系统加速全球落地 的战略基石</p>
              <a class="explore" @click="jump('/partners')">探讨</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="home-ten">
      <div class="ten-inner">
        <h2>适合你的解决方案是什么？</h2>
        <ul>
          <li>
            <h3>有产品但缺乏海外<br />渠道的制造型企业</h3>
            <p>
              Xport提供从选品策划、平台入驻、本地化运营到物流清关全流程支持，帮助工厂型企业快速构建海外直销能力，实现从代工到品牌的转型升级。
            </p>
          </li>
          <li>
            <h3>有销售能力但缺乏稳<br />定供应链的跨境卖家</h3>
            <p>
              Xport整合全球优质供应链资源与智能选品系统为卖家提供稳定、高性价比的商品对接方案，并通过AI驱动的市场趋势分析，助其精准投放、降低试错成本、提升利润空间，真正实现双边协司、高效出海。
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="home-end">
      <div class="home-end-inner">
        <h2>让世界成为你的市场</h2>
        <a>让我们谈谈</a>
      </div>
    </div>
  </section>
</template>

<script>
import HomeSix from './components/HomeSix.vue'
import HomeEight from './components/HomeEight.vue'
export default {
  name: 'xport-home',
  components: { HomeSix, HomeEight },
  data() {
    return {
      threeList: [
        {
          id: 1,
          imageUrl: require('@/assets/eco/amazon1.png')
        },
        {
          id: 2,
          imageUrl: require('@/assets/eco/shein.svg')
        },
        {
          id: 3,
          imageUrl: require('@/assets/eco/shopify.svg')
        },
        {
          id: 4,
          imageUrl: require('@/assets/eco/temu.svg')
        },
        {
          id: 5,
          imageUrl: require('@/assets/eco/tiktok.svg')
        },
        {
          id: 6,
          imageUrl: require('@/assets/eco/wayfair.svg')
        },
        {
          id: 7,
          fill: '#ee4d2d',
          imageUrl: require('@/assets/eco/shopee.svg')
        },
        {
          id: 8,
          imageUrl: require('@/assets/eco/chewy.png')
        },
        {
          id: 9,
          imageUrl: require('@/assets/eco/ebay.svg')
        },
        {
          id: 10,
          imageUrl: require('@/assets/eco/walmart.png')
        }
      ]
    }
  },
  computed: {
    threeCarouselList() {
      let end = []
      if (this.threeList.length >= 8) {
        end = this.threeList.filter((n, i) => i < 8)
      } else if (this.threeList.length >= 4) {
        end = [...this.threeList, ...this.threeList]
      } else if (this.threeList.length > 0) {
        for (let index = 0; index < 8; index++) {
          end = [...end, ...this.threeList]
        }
      }
      return [...this.threeList, ...end]
    }
  },
  methods: {
    handleJumpPage() {
      this.$router.push('/consultation')
    },
    jump(path, isNew) {
      if (path.indexOf('http') !== -1) {
        if (isNew) {
          window.open(path)
        } else {
          window.location.href = path
        }
      } else {
        if (isNew) {
          window.open(path)
        } else {
          this.$router.push(path)
        }
      }
    },
    handleEvent(type) {
      if (type === 1) {
        window.open('http://13.8.70.235:28384/xcp/index')
      }
    }
  }
}
</script>

<style scoped lang="less">
.xport-home {
  background-color: #fdfdfd;

  .home-one {
    z-index: 2;
    position: relative;

    .eco-list {
      background: #ffffffb8;
      border-radius: 20px;
    }

    .btn {
      width: 220px;
      height: 56px;
      line-height: 60px;
      text-align: center;
      background-color: #2f5ad9;
      border-radius: 30px;
      border: 4px solid #2f5ad9;
      color: #fff;
      font-size: 20px;
      font-weight: 700;
      cursor: pointer;

      &:hover {
        background-color: #fff;
        color: #2f5ad9;
      }
    }
  }

  .home-two {
    padding: 0 5%;
    border-bottom: 6px solid #2f5ad9;

    .two-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 40px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 40px;

      .two-item {
        flex: 1;
        text-align: center;

        .item-num {
          color: #2f5ad9;
          font-size: 56px;
          font-weight: 700;
          font-family: 'Poppins', sans-serif;
        }

        .item-text {
          font-size: 16px;
          font-weight: 700;
        }
      }

      .item-line {
        width: 3px;
        height: 60px;
        background-color: #2a2c2f1a;
      }
    }
  }

  .home-three {
    // padding-top: -60px;
    margin-top: -60px;
    height: 45px;
    overflow-x: hidden;

    .three-inner {
      --num: 8;
      width: fit-content;
      display: flex;
      align-items: center;
      gap: 90px;
      animation: calc(var(--num) * 1.5s) linear 0s infinite running carousel;

      img {
        max-width: 9vw;
        height: 2vw !important;

        &:last-child {
          margin-right: 86px;
        }
      }
    }
  }

  .home-four {
    display: flex;

    .four-1,
    .four-2,
    .four-3 {
      flex: 1;

      img {
        width: 100%;
      }
    }

    .four-2 {
      .four-2-top {
        height: 19.2vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 30px;
        text-align: center;

        h2 {
          font-size: 40px;
          font-weight: 700;
        }

        p {
          font-size: 16px;
          margin: 20px 0;
        }
      }
    }
  }

  .home-five {
    padding: 0 5%;
    background-image: url('../../assets/home/home-five-bg.svg');
    background-position: top right;
    background-repeat: no-repeat;
    background-size: 26% auto;

    .five-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 60px 0;
      text-align: center;

      h2 {
        font-size: 48px;
        font-weight: 700;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
      }

      ul {
        margin: 40px 0 50px;
        display: flex;
        justify-content: space-between;
        gap: 20px;
        background-color: #fff;

        li {
          flex: 1;
          padding: 50px 23px;
          border: 1px solid #2a2c2f1a;
          text-align: center;

          img {
            width: 150px;
          }

          h3 {
            margin: 8px 0 16px;
            font-size: 24px;
            font-weight: 700;

            &::after {
              content: '';
              display: block;
              width: 80%;
              height: 0;
              border: 2px solid #2f5ad9;
              margin: 10px auto;
            }
          }

          p {
            font-size: 16px;
            margin: 20px 0;
          }
        }
      }

      .btn-box {
        display: flex;
        justify-content: center;

        .btn {
          width: auto;
          padding: 14px 38px;
          background-color: #2f5ad9;
          border-radius: 50px;
          border: 4px solid #2f5ad9;
          color: #fff;
          font-size: 18px;
          font-weight: 700;

          &:hover {
            background-color: #fff;
            color: #2f5ad9;
          }
        }
      }
    }
  }

  .home-seven {
    padding: 0 5%;
    background-color: #000000;

    .seven-inner {
      width: 900px;
      margin: 0 auto;
      padding: 50px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 40px;

      h2 {
        width: 440px;
        font-size: 36px;
        color: #fff;
      }

      a {
        padding: 16px 40px;
        border: 4px solid #2f5ad9;
        border-radius: 60px;
        background-color: #2f5ad9;
        color: #fff;
        font-size: 18px;
        font-weight: 700;

        &:hover {
          background-color: #000000;
          color: #2f5ad9;
        }
      }
    }
  }

  .home-nine {
    padding: 0 5%;
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.13);

    .nine-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 80px 0;

      h2 {
        font-size: 48px;
        text-align: center;
      }

      ul {
        margin-top: 60px;
        display: flex;
        justify-content: space-between;
        gap: 50px;

        li {
          flex: 1;
          box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.15);
          border-radius: 9px;
          overflow: hidden;

          img {
            width: 100%;
            height: 200px;
          }

          .text {
            height: 125px;
            padding: 35px;
            display: flex;
            flex-direction: column;

            h3 {
              font-style: 24px;
            }

            p {
              margin: 15px 0;
            }

            .explore {
              margin-top: auto;
              font-size: 14px;
              font-weight: 700;
              transition: all 0.5s;

              &::after {
                content: url('../../assets/home/home-right.svg');
                display: inline-block;
                transform: scale(0.8);
                margin-left: 10px;
              }

              &:hover {
                transform: translateX(6px);
                color: #2f5ad9;
              }
            }
          }
        }
      }
    }
  }

  .home-ten {
    padding: 0 5%;

    .ten-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 50px 0;

      h2 {
        font-size: 48px;
        text-align: center;
      }

      ul {
        width: 930px;
        margin: 50px auto 0;
        display: flex;
        gap: 50px;

        li {
          flex: 1;
          padding: 50px;
          border: 3px solid #f5f5f6;
          border-radius: 9px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          gap: 20px;

          h3 {
            width: 280px;
            padding-bottom: 20px;
            border-bottom: 3px solid #2f5ad9;
            font-size: 30px;
            text-align: center;
          }

          p {
            text-align: center;
            line-height: 1.7;
          }
        }
      }
    }
  }

  .home-end {
    padding: 0 5%;
    border-bottom: 1px solid #000000;

    .home-end-inner {
      width: 1140px;
      margin: 0 auto;
      padding-bottom: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 50px;

      h2 {
        font-size: 48px;
      }

      a {
        padding: 16px 40px;
        font-size: 18px;
        color: #fff;
        border: 3px solid #2f5ad9;
        border-radius: 30px;
        background-color: #2f5ad9;

        &:hover {
          background-color: #fff;
          color: #2f5ad9;
        }
      }
    }
  }
}

@keyframes carousel {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(calc(-100% + 100vw));
  }
}
</style>
